import { getTokens } from '@/lib/auth'

export class TranscribeError extends Error {
  status: number
  constructor(message: string, status: number) {
    super(message)
    this.name = 'TranscribeError'
    this.status = status
  }
}

/**
 * Отправляет аудио на серверный прокси `/api/voice/transcribe` и возвращает распознанный текст.
 * `signal` — для отмены («скип»): прокси пробрасывает abort и провайдеру.
 */
export async function transcribeAudio(blob: Blob, signal?: AbortSignal): Promise<string> {
  const token = getTokens()?.accessToken
  if (!token) {
    throw new TranscribeError('Требуется авторизация', 401)
  }

  const ext = blob.type.includes('mp4') ? 'mp4' : blob.type.includes('ogg') ? 'ogg' : 'webm'
  const formData = new FormData()
  formData.append('audio', blob, `voice.${ext}`)

  let response: Response
  try {
    response = await fetch('/api/voice/transcribe', {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
      body: formData,
      signal,
    })
  } catch (error) {
    if (signal?.aborted || (error instanceof Error && error.name === 'AbortError')) throw error
    throw new TranscribeError('Нет соединения с сервером', 0)
  }

  let payload: { text?: string; error?: string } | null = null
  try {
    payload = await response.json()
  } catch {
    payload = null
  }

  if (!response.ok) {
    throw new TranscribeError(payload?.error || `Ошибка распознавания (HTTP ${response.status})`, response.status)
  }

  return typeof payload?.text === 'string' ? payload.text : ''
}
